import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {loginUiTexts, gameUiTexts} from 'data/ui-texts';
import Logo from 'components/ui/logo/logo';
import Button from 'components/ui/button/button';
import './game-done-group.scss';

const GameDoneGroup = ({scenarioId, resetGameProgress, handleLogout, updateBackground}) => {

	useEffect(() => {
		// Set background image id
		updateBackground('login', scenarioId);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="GameDoneGroup">
			<div className='GameDoneGroup-logoWrapper'>
				<Logo scenarioId={scenarioId} page="landing"/>
			</div>

			<div className="GameDoneGroup-text">
				<span>{gameUiTexts.waitForFacilitator}</span>
			</div>

			{/* Logout button */}
			<div className="GameDoneGroup-logoutBtn">
				<Button 
					classes={['login']} 
					text={loginUiTexts.logout}
					onClick={() => {handleLogout();}}
				/>
			</div>

			{/* Reset game btn */}
			{(appConfig.env === 'development' || appConfig.env === 'test') && 
				<div className="GameDoneGroup-resetBtn">
					<Button 
						classes={['login']} 
						text={gameUiTexts.resetBtn}
						onClick={() => {resetGameProgress();}}
					/>
				</div>
			}
		</div>
	);
};

GameDoneGroup.propTypes = {
	scenarioId: PropTypes.string.isRequired,
	resetGameProgress: PropTypes.func.isRequired,
	handleLogout: PropTypes.func.isRequired,
	updateBackground: PropTypes.func.isRequired
};

export default GameDoneGroup;
